var Industry = "Industri";
var Aerospace = "Dirgantara";
var Agriculture = "Pertanian";
var Automotive = "Otomotif";
var Education = "Pendidikan";
var Gaming = "Game";
var Government = "Pemerintahan";
var Healthcare = "Layanan kesehatan";
var Hospitality = "Perhotelan";
var Manufacturing = "Manufaktur";
var Mining = "Pertambangan";
var Other = "Lainnya";
var Retail = "Ritel";
var Telecommunications = "Telekomunikasi";
var Travel = "Perjalanan";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Komputer & Elektronik",
	"Consumer goods": "Barang Konsumen",
	Education: Education,
	"Financial services": "Layanan Keuangan",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Ilmu Alam",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Pemasaran & Periklanan",
	"Media & entertainment": "Media & Hiburan",
	Mining: Mining,
	"Non-profit organization": "Organisasi Nirlaba",
	"Oil & gas": "Minyak & Gas",
	Other: Other,
	"Power & utilities": "Listrik & Utilitas",
	"Professional services": "Layanan Profesional",
	"Real estate & construction": "Real Estate & Konstruksi",
	Retail: Retail,
	"Software & internet": "Perangkat Lunak & Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Transportasi & Logistik",
	Travel: Travel,
	"Wholesale & distribution": "Grosir & Distribusi"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
